import React from "react";
import GerarCodigo from "../../../components/acesso-rapido/pix/gerar-codigo-pix/GerarCodigoPix";

export default function () {
  return <GerarCodigo />;
}
